// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomeBlogPostsWrapperStyle-module--wrapper--3HU79","title":"HomeBlogPostsWrapperStyle-module--title--Rk_WC"};